// https://stackoverflow.com/questions/63961803/eslint-says-all-enums-in-typescript-app-are-already-declared-in-the-upper-scope
/* eslint-disable no-shadow */
export enum AccessibilityHtmlTags {
  MainHeader = 'h1',
  SecondaryHeader = 'h2',
  Paragraph = 'p',
}
